'use strict';

module.exports = function (ngModule) {
    ngModule.controller('surveyController', require('./survey'));
}


/** WEBPACK FOOTER **
 ** ./src/pages/controllers/survey/index.js
 **/